import React, { useState } from "react";

import { message, Typography } from "antd";

import variableLanguage from "../../../../../../utils/hookGetVariablesLanguage";
import useTimer from "../../../../../../utils/hooks/useTimer";
import requests from "../../../../../axios/requests";
import Button from "../../../../../components/Button/Button";
import PrevButton from "../../../../../components/PrevButton/PrevButton";
import ModalWelcome from "../../../../../pages/Auth/ModalWelcome/ModalWelcome";
import "./RegMode.scss";

const { Link: AntdLink } = Typography;

function RegMode({ sessionId }) {
  const variables_66 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_66",
  });
  const variables_68 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_68",
  });
  const variables_69 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_69",
  });
  const variables_70 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_70",
  });
  const variables_71 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_71",
  });
  const variables_72 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_72",
  });
  const variables_73 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_73",
  });
  const variables_79 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_79",
  });
  const variables_80 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_80",
  });
  const variables_81 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_81",
  });
  const variables_82 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_82",
  });
  const variables_83 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_83",
  });
  const variables_84 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_84",
  });
  const variables_85 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_85",
  });
  const variables_86 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_86",
  });
  const { timeLeft, isFinished, isRunning, start, pause, resume, reset } =
    useTimer(60, () => {
      console.log("Таймер завершен!");
    });
  const [step, setStep] = useState(1);
  const [valueEmailCode, setValueEmailCode] = useState("");
  const [valueEmail, setEmail] = useState("");
  const [onChecked, setOnChecked] = useState(false);
  const [valueFio, setValueFio] = useState("");
  const [image, setImage] = useState("");
  const [name, setName] = useState("");

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const onlyDigitsPattern = /^\d+$/;

  const inputConfirmHandlerEmail = (e) => {
    setEmail(e.target.value);
  };
  const inputConfirmHandlerEmailCode = (e) => {
    setValueEmailCode(e.target.value);
  };
  const inputConfirmHandlerFio = (e) => {
    setValueFio(e.target.value);
  };
  const repeatedEmailHandler = (e) => {
    requests.auth
      .verify_email({ email: valueEmail, mode: "login" })
      .then(() => {
        setStep(2);
        reset();
        start();
      })
      .catch((error) => {
        console.log("error", error);
        let messageDetail;
        if (
          error.response &&
          error.response.data &&
          error.response.data.detail
        ) {
          messageDetail = error.response.data.detail;
          message.warn(messageDetail);
        } else if (error.detail) {
          messageDetail = error.detail;
          message.warn(messageDetail);
        } else {
          messageDetail = "Неизвестная ошибка";
          message.warn(messageDetail);
        }
      });
  };
  const loginHandlerEmail = (e) => {
    e.preventDefault();
    if (!valueEmail) message.warn(variables_79);
    if (!valueFio) message.warn(variables_80);
    if (!emailPattern.test(valueEmail)) {
      message.warn(variables_72);
      return;
    }
    let objSend = {
      fio: valueFio,
      avatar: "",
      email: valueEmail,
      send_email: false,
      ...(location?.search
        ? { invite: location.search.replace("?invite=", "") }
        : {}),
    };
    requests.auth
      .register_user(objSend)
      .then(() => {
        setTimeout(() => {
          requests.auth
            .verify_email({ email: valueEmail, mode: "login" })
            .then(() => {
              setStep(2);
              reset();
              start();
            })
            .catch((error) => {
              console.log("error", error);
              let messageDetail;
              if (
                error.response &&
                error.response.data &&
                error.response.data.detail
              ) {
                messageDetail = error.response.data.detail;
                message.warn(messageDetail);
              } else if (error.detail) {
                messageDetail = error.detail;
                message.warn(messageDetail);
              } else {
                messageDetail = "Неизвестная ошибка";
                message.warn(messageDetail);
              }
            });
        }, 1500);
      })
      .catch((e) => {
        console.log("error", e);
        message.warn(variables_73);
      });
  };
  const loginHandlerEmailCode = (e) => {
    e.preventDefault();
    if (!onlyDigitsPattern.test(valueEmailCode)) {
      message.warn(variables_71);
      return;
    }
    requests.users
      .validate_sms({
        code: valueEmailCode,
        email: valueEmail,
      })
      .then((response) => {
        if (response.status === 203) {
          console.log("status203");
          message.warn(variables_69);
          return;
        }

        setStep(3);

        setImage(response.data.image);
        setName(response.data.name);
        if (response.data?.user_exists) {
          // если неаутентифицированный пользователь просматривал страницу, то редирект его на эту страницу.
          if (window.localStorage.getItem("previous_course_link")) {
            window.localStorage.setItem("token", response.data.auth_token);
            window.localStorage.setItem("username", response.data.name);
            window.localStorage.setItem("last_name", response.data.last_name);
            window.localStorage.setItem(
              "middle_name",
              response.data.middle_name
            );
            window.location.href = window.localStorage.getItem(
              "previous_course_link"
            );
            setTimeout(() => {
              window.localStorage.removeItem("previous_course_link");
            }, 1000);
            return;
          }

          window.localStorage.setItem("token", response.data.auth_token);
          window.localStorage.setItem("username", response.data.name);
          window.localStorage.setItem("last_name", response.data.last_name);
          window.localStorage.setItem("middle_name", response.data.middle_name);
        } else {
          console.log("иначе вернуть куда то там");
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <div>
      {step === 1 && (
        <div className="form_reg">
          <input
            className="auth-item input"
            value={valueFio}
            onChange={inputConfirmHandlerFio}
            placeholder={variables_81}
          />
          <input
            className="auth-item input"
            value={valueEmail}
            onChange={inputConfirmHandlerEmail}
            placeholder={variables_66}
          />
          <div className="checkbox_group">
            <div className="form-group">
              <input
                type="checkbox"
                id={"remember"}
                onChange={(e) => setOnChecked(e.target.checked)}
              />
              <label htmlFor={"remember"} />
              <span style={{ color: "#A2AACA" }}>{variables_82}</span>
              <span>
                <AntdLink
                  className={"a"}
                  href="https://skillometer.ru/legal"
                  target="_blank"
                >
                  {variables_83}
                </AntdLink>
              </span>
              <span> {variables_84} </span>
              <span>
                <AntdLink
                  className={"a"}
                  href="https://skillometer.ru/offer"
                  target="_blank"
                >
                  {variables_85}
                </AntdLink>
              </span>
            </div>
          </div>
          <Button
            text={variables_86}
            click={loginHandlerEmail}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
            disabled={!onChecked}
          />
        </div>
      )}
      {step === 2 && (
        <>
          <PrevButton click={() => setStep(1)} />
          <input
            className="auth-item input"
            value={valueEmailCode}
            onChange={inputConfirmHandlerEmailCode}
            placeholder={variables_68}
            maxLength={4}
          />
          {!isFinished ? (
            <div className="auth-item_timer">Осталось {timeLeft} секунд</div>
          ) : (
            <div
              className="auth-item_again_code"
              onClick={repeatedEmailHandler}
            >
              Код не пришел? <span>&nbsp;Получить код снова</span>
            </div>
          )}
          <Button
            text={variables_70}
            click={loginHandlerEmailCode}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
          />
        </>
      )}
      {step === 3 && (
        <ModalWelcome
          image={image}
          name={name}
          setImage={setImage}
          sessionId={sessionId}
        />
      )}
    </div>
  );
}

export default RegMode;
